import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Pipe({
  name: 'showErrors'
})
export class ShowErrorsPipe implements PipeTransform {

  transform(control: AbstractControl, isSubmitted: boolean = false): boolean {
    if (control.invalid && control.errors != null) {
      if (control.errors.required != null || control.errors.isUnique != null) {
        return isSubmitted;
      }
      return control.dirty || control.touched;
    }
    return false;
  }
}
